import React, { useRef, useEffect } from 'react';
import FlyLineLayer from './FlyLineLayer';
import { useUpdateEffect } from 'ahooks';
import { registerEventLayer } from '../events';
import useProps from '../_util/useProps';

export default function(props) {
    const {
        data,
        features,
        url,
        params,
        zIndex,
        id: key,
        _key,
        name,
        style,
        labelField,
        template,
        show = true,
        groupLayer,
        legend,
        height,
        color,
        speed,
        width,
        flyWidth,
        layerControl = true,
        number,
        glowPower,
    } = props;
    const layerRef = useRef();
    const { map } = useProps();

    useEffect(() => {
        let layer = new FlyLineLayer({
            data,
            features,
            url,
            params,
            style,
            zIndex,
            key: key || _key,
            name,
            labelField,
            template,
            show,
            legend,
            height,
            color,
            speed,
            map,
            groupLayer,
            width,
            flyWidth,
            layerControl,
            number,
            glowPower,
        });

        // 注册事件
        registerEventLayer(layer, props);

        if (groupLayer) {
            groupLayer.addLayer(layer);
        } else {
            map.addLayer(layer);
        }

        layerRef.current = layer;
        return () => {
            if (groupLayer) {
                groupLayer.removeLayer(layer);
            } else {
                map.removeLayer(layer);
            }
        };
    }, []);

    useUpdateEffect(() => {
        layerRef.current.loadData(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        layerRef.current.show = show;
    }, [show]);

    return <></>;
}
